import { createAction, props } from '@ngrx/store';
import { BulkImportEmployee } from '../models/bulk-import-employees.model';
import {
  IBulkImportEmployeesRequestBody,
  UpdateAllEmployeesDetails,
  UpdateAllEmployeesProducts
} from '../models/view-employee.model';
import { IGetBulkEmployeeUpdateFromExcelStatusResponse } from '../models/get-bulk-employee-update-from-excels-status.model';
import { IBusinessDetailResponse } from '../../businesses-detail/models/business-detail.model';
import { IAcceptUpdateRequest } from '../models/accept-selected-updates.model';
import { IUndoSelectedUpdateRequest } from '../models/undo-selected-updates.model';
import { IManageUsersSetupResponse } from '../../businesses-detail/models/manage-users-setup.model';
import { ISendInviteRequest } from '../../../shared/models/shared.model';

// Update All Users Personal Details
export const updateUser = createAction(
  '[AllUsers] Update AllUsers',
  props<{
    request: {
      businessId: string;
      userProfileId: string;
      body: UpdateAllEmployeesDetails;
    };
  }>()
);

export const updateUserSuccess = createAction('[AllUsers] Update AllUsers Success', props<{ response: string }>());

export const updateUserFailure = createAction('[AllUsers] Update AllUsers Failure', props<{ error: Error | any }>());

// Update All Users Personal Details
export const updateUpdatedUser = createAction(
  '[AllUsers] Update UpdatedUsers',
  props<{
    request: {
      businessId: string;
      bulkEmployeeUpdateEmployeeId: string;
      body: UpdateAllEmployeesDetails;
    };
  }>()
);

export const updateUpdatedUserSuccess = createAction('[AllUsers] Update UpdatedUsers Success', props<{ response: string }>());

export const updateUpdatedUserFailure = createAction('[AllUsers] Update UpdatedUsers Failure', props<{ error: Error | any }>());

// Update All New Users Personal Details
export const updateNewUser = createAction(
  '[AllUsers] Update New Users',
  props<{
    request: {
      businessId: string;
      businessInviteId: string;
      body: UpdateAllEmployeesDetails;
    };
  }>()
);

export const updateNewUserSuccess = createAction('[AllUsers] Update New Users Success', props<{ response: string }>());

export const updateNewUserFailure = createAction('[AllUsers] Update New Users Failure', props<{ error: Error | any }>());

export const loadBulkImportEmployees = createAction(
  '[ViewEmployees] Load BulkImportEmployees',
  props<{
    request: {
      businessId: string;
      body: IBulkImportEmployeesRequestBody;
      noLoader: boolean;
    };
  }>()
);

export const loadBulkImportEmployeesSuccess = createAction('[ViewEmployees] Load BulkImportEmployees Success', props<{ response: any }>());

export const loadBulkImportEmployeesFailure = createAction(
  '[ViewEmployees] Load BulkImportEmployees Failure',
  props<{ error: Error | any }>()
);

export const loadBulkEmployeesUpdateHistory = createAction(
  '[ViewEmployees] Load BulkEmployeesUpdateHistory',
  props<{
    request: {
      businessId: string;
    };
  }>()
);

export const loadBulkEmployeesUpdateHistorySuccess = createAction(
  '[ViewEmployees] Load BulkEmployeesUpdateHistory Success',
  props<{ response: any }>()
);

export const loadBulkEmployeesUpdateHistoryFailure = createAction(
  '[ViewEmployees] Load BulkEmployeesUpdateHistory Failure',
  props<{ error: Error | any }>()
);

export const downloadBulkImportEmployees = createAction(
  '[ViewEmployees] Load DownloadBulkImportEmployees',
  props<{
    request: {
      businessId: string;
      templateTypeId: string;
    };
  }>()
);

export const downloadBulkImportEmployeesSuccess = createAction(
  '[ViewEmployees] Load DownloadBulkImportEmployees Success',
  props<{ response: any }>()
);

export const downloadBulkImportEmployeesFailure = createAction(
  '[ViewEmployees] Load DownloadBulkImportEmployees Failure',
  props<{ error: Error | any }>()
);

export const sendSelectedEmployeeInvitations = createAction(
  '[SendSelectedEmployeeInvitation] Load SendSelectedEmployeeInvitations',
  props<{ businessId: string; businessInviteIdList: ISendInviteRequest; bulkImportEmployeesRequestBody: IBulkImportEmployeesRequestBody }>()
);

export const sendSelectedEmployeeInvitationsSuccess = createAction(
  '[SendvSelectedEmployeeInvitation] Load SendSelectedEmployeeInvitations Success',
  props<{ response: string }>()
);

export const sendSelectedEmployeeInvitationsFailure = createAction(
  '[SendSelectedEmployeeInvitation] Load SendSelectedEmployeeInvitations Failure',
  props<{ error: Error | any }>()
);

export const sendBulkEmployeeInvitations = createAction(
  '[SendInvitation] Load SendInvitations',
  props<{ businessId: string; bulkImportEmployees: BulkImportEmployee[] }>()
);

export const sendBulkEmployeeInvitationsSuccess = createAction(
  '[SendInvitation] Load SendInvitations Success',
  props<{ response: string }>()
);

export const sendBulkEmployeeInvitationsFailure = createAction(
  '[SendInvitation] Load SendInvitations Failure',
  props<{ error: Error | any }>()
);

export const acceptSelectedUpdates = createAction(
  '[ViewEmployees] Load AcceptSelectedUpdates',
  props<{ businessId: string; userProfileIdList: IAcceptUpdateRequest; bulkImportEmployeesRequestBody: IBulkImportEmployeesRequestBody }>()
);

export const acceptSelectedUpdatesSuccess = createAction(
  '[ViewEmployees] Load AcceptSelectedUpdates Success',
  props<{ response: string }>()
);

export const acceptSelectedUpdatesFailure = createAction(
  '[ViewEmployees] Load AcceptSelectedUpdates Failure',
  props<{ error: Error | any }>()
);

export const acceptBulkEmployeeUpdates = createAction(
  '[ViewEmployees] Load Accept Updates',
  props<{ businessId: string; bulkImportEmployees: BulkImportEmployee[] }>()
);

export const acceptBulkEmployeeUpdatesSuccess = createAction('[ViewEmployees] Load Accept Updates Success', props<{ response: string }>());

export const acceptBulkEmployeeUpdatesFailure = createAction(
  '[ViewEmployees] Load Accept Updates Failure',
  props<{ error: Error | any }>()
);

export const acceptBulkEmployeeUpdatesAndSendInvites = createAction(
  '[ViewEmployees] Load AcceptUpdatesAndSendInvites',
  props<{ businessId: string; bulkImportEmployees: BulkImportEmployee[] }>()
);

export const acceptBulkEmployeeUpdatesAndSendInvitesSuccess = createAction(
  '[ViewEmployees] Load AcceptUpdatesAndSendInvites Success',
  props<{ response: string }>()
);

export const acceptBulkEmployeeUpdatesAndSendInvitesFailure = createAction(
  '[ViewEmployees] Load AcceptUpdatesAndSendInvites Failure',
  props<{ error: Error | any }>()
);

// Update All Users Products
export const loadUpdateProductRequest = createAction(
  '[UpdateAllUsersProducts] Update AllUsers Product Request',
  props<{
    businessId: string;
    userProfileId: string;
    productId: string;
    body: UpdateAllEmployeesProducts;
  }>()
);

export const loadUpdateProductSuccess = createAction(
  '[UpdateAllUsersProducts] Update AllUsers Product Response',
  props<{
    response: string;
  }>()
);

export const loadUpdateProductFailure = createAction(
  '[UpdateAllUsersProducts] Update AllUsers Product Failure',
  props<{
    error: Error | any;
  }>()
);

export const updateUpdatedProduct = createAction(
  '[UpdateUpdatedProducts] Update Updated Product Request',
  props<{
    businessId: string;
    bulkEmployeeUpdateProductId: string;
    body: UpdateAllEmployeesProducts;
  }>()
);

export const updateUpdatedProductSuccess = createAction(
  '[UpdateUpdatedProducts] Update Updated Product Response',
  props<{
    response: string;
  }>()
);

export const updateUpdatedProductFailure = createAction(
  '[UpdateUpdatedProducts] Update Updated Product Failure',
  props<{
    error: Error | any;
  }>()
);

// Update new product data
export const updateNewProduct = createAction(
  '[UpdateNewProduct] Update New Product Request',
  props<{
    businessId: string;
    businessInviteId: string;
    body: UpdateAllEmployeesProducts;
  }>()
);

export const updateNewProductSuccess = createAction(
  '[UpdateNewProduct] Update New Product Response',
  props<{
    response: string;
  }>()
);

export const updateNewProductFailure = createAction(
  '[UpdateNewProduct] Update New Product Failure',
  props<{
    error: Error | any;
  }>()
);

export const getBulkEmployeeUpdateFromExcelsStatus = createAction(
  '[ViewEmployees] Load GetBulkEmployeeUpdateFromExcelStatus',
  props<{ businessId: string; bulkImportInviteHistoryId: string; noLoader: boolean }>()
);

export const getBulkEmployeeUpdateFromExcelsStatusSuccess = createAction(
  '[ViewEmployees] Load GetBulkEmployeeUpdateFromExcelStatus Success',
  props<{ response: IGetBulkEmployeeUpdateFromExcelStatusResponse }>()
);

export const getBulkEmployeeUpdateFromExcelsStatusFailure = createAction(
  '[ViewEmployees] Load GetBulkEmployeeUpdateFromExcelStatus Failure',
  props<{ error: Error | any }>()
);

export const getBusiness = createAction('[ViewEmployees] Load GetBusiness', props<{ businessId: string }>());

export const getBusinessSuccess = createAction(
  '[ViewEmployees] Load GetBusiness Success',
  props<{ response: IBusinessDetailResponse[] }>()
);

export const getBusinessFailure = createAction('[ViewEmployees] Load GetBusiness Failure', props<{ error: Error | any }>());

export const getManageUsersSetup = createAction('[ViewEmployees] Load GetManagesUserSetup', props<{ businessId: string }>());

export const getManageUsersSetupSuccess = createAction(
  '[ViewEmployees] Load GetManageUsersSetup Success',
  props<{ response: IManageUsersSetupResponse }>()
);

export const getManageUsersSetupFailure = createAction('[ViewEmployees] Load GetManageUsersSetup Failure', props<{ error: Error | any }>());

export const undoSelectedUpdates = createAction(
  '[ViewEmployees] Load UndoSelectedUpdates',
  props<{ businessId: string; usersIdList: IUndoSelectedUpdateRequest; bulkImportEmployeesRequestBody: IBulkImportEmployeesRequestBody }>()
);

export const undoSelectedUpdatesSuccess = createAction('[ViewEmployees] Load UndoSelectedUpdates Success', props<{ response: string }>());

export const undoSelectedUpdatesFailure = createAction('[ViewEmployees] Load UndoSelectedUpdates Failure', props<{ error: Error | any }>());

export const undoBulkEmployeeUpdates = createAction(
  '[ViewEmployees] Load Undo Updates',
  props<{ businessId: string; bulkImportEmployeesRequestBody: IBulkImportEmployeesRequestBody }>()
);

export const undoBulkEmployeeUpdatesSuccess = createAction('[ViewEmployees] Load Undo Updates Success', props<{ response: string }>());

export const undoBulkEmployeeUpdatesFailure = createAction('[ViewEmployees] Load Undo Updates Failure', props<{ error: Error | any }>());
